import * as React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import useMboxCall from '@ally/use-mbox-call';
import { Box, TextBody, get, muiBankTheme, Icon } from '@ally/metronome-ui';
import { muiInfoFill } from '@ally/metronome-icons';
import { AllyTruthmark } from '../../../Svgs';
// Don't have direct access to links within any parsed HTML to apply styling, so doing it at a parent
const StyledText = styled(TextBody) `
  a {
    text-decoration: none;
    font-weight: bold;
    font-size: ${get.fontSizes('sm')};
    color: ${get.colors('bluesuedeshoes')};
  }
`;
const ColorizedMbox = styled(Box) `
  ${({ theme: { media, colors, space }, color = 'unset' }) => `
    border: 1px solid ${colors['slate-3']};
    border-radius: 6px;
    box-shadow: 0px 1px 2px ${colors['slate-3']};
    ${media.up('lg')} {
      width: 60%;
      padding: ${space.sm};
      padding-left: ${space.md};
    }
    padding-left: ${space.md};
    background-color: ${colors.white};
    margin-bottom: ${space.md};
    position: relative;
    span a {
      color: ${colors.bluesuedeshoes};
      text-decoration: none;
      font-weight: bold;
    }
    &:before {
      // @ts-ignore
      background-color: ${color};
      border-color: ${color};
      transition: all .3s ease;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 10px;
      left: 2px;
      top: 2px;
      bottom: 2px;
    }
  `}
`;
function isRelativeLink(link) {
    const { origin } = window.location;
    // path is relative if the link includes the origin name or starts with '/' or '#/'
    return link.includes(origin) || /^[/#]*\//.test(link);
}
function sanitizeExternalLink(href) {
    const { origin, pathname } = window.location;
    return isRelativeLink(href)
        ? href.replace(origin, '').replace(pathname, '')
        : null;
}
export const MboxTemplate = ({ content, template, className, }) => {
    const history = useHistory();
    /*
     * MD Parser will always treat links as external, handle links that are internal to make sure we route correctly
     * Most of this logic was ported from the Ember application, with some modifications
     * This may need support for hash routing in the future
     */
    const handleClick = (event) => {
        const clickedElement = event.target;
        if (clickedElement.nodeName === 'A') {
            const { href } = clickedElement;
            const normalizedHref = sanitizeExternalLink(href);
            // If relative URL (same origin or leading /) we skip the target="_blank" set by the parser
            if (normalizedHref) {
                event.preventDefault();
                history.push(normalizedHref);
            }
        }
    };
    switch (template) {
        case 'insight':
            return (React.createElement(Box, { my: "sm", display: "flex", className: className, "data-testid": "insight-mbox" },
                React.createElement(AllyTruthmark, null),
                React.createElement(StyledText, { tag: "span", size: "sm", 
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    dangerouslySetInnerHTML: content, onClick: handleClick })));
        case 'icon-notification':
            return (React.createElement(Box, { my: "sm", mb: "lg", display: "flex", className: className, "data-testid": "styledMbox-icon-notification" },
                React.createElement(Icon, { icon: muiInfoFill, fill: "plum", size: "md", mt: "3px", mr: "sm", "data-testid": "styledMbox-info-icon" }),
                React.createElement(StyledText, { tag: "span", size: "sm", 
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    dangerouslySetInnerHTML: content, onClick: handleClick })));
        default:
            return (React.createElement(TextBody, { tag: "span", size: "sm", "data-testid": "standard-mbox", 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                dangerouslySetInnerHTML: content, onClick: handleClick, className: className }));
    }
};
export const StyledMbox = ({ name, defaultContent = { content: null, template: null }, className, }) => {
    var _a;
    const defaults = {
        content: '',
        template: null,
        color: null,
    };
    const { content, template, color } = (_a = useMboxCall(name, defaultContent, true).mboxData) !== null && _a !== void 0 ? _a : defaults;
    const cleanMarkup = { __html: `${content}` };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const kolor = muiBankTheme.colors[color];
    if (content) {
        // 'icon-notification' template doesn't need the border and styling of ColorizedMbox
        if (template === 'icon-notification') {
            return (React.createElement(MboxTemplate, { content: cleanMarkup, template: template, className: className }));
        }
        return (React.createElement(ColorizedMbox, { color: kolor, "data-testid": "colorized-mbox" },
            React.createElement(MboxTemplate, { content: cleanMarkup, template: template, className: className })));
    }
    return null;
};
export default StyledMbox;
//# sourceMappingURL=StyledMbox.js.map